import React, { useContext } from 'react';
import { IndexContext } from "../../context";

const Blog = ({ blogRightShape, blogItems, styles = {} }) => {
  const { baseUrl } = useContext(IndexContext);

  return (
    <section className="index-atp-blog" id="blog">
      <figure className={`index-airplane-top-right-figure ${styles.twitterFigure}`}>
        <span>
          <a href="https://twitter.com/search?q=AirTourPro&src=typed_query" target="_blank">
            @AirTourPro
          </a>
        </span>
        <picture>
          <source media="(min-width: 1261px)" srcSet={blogRightShape.imgPlanPng} type="image/png" />
          <source media="(max-width: 1260px)" srcSet="data:image/gif;base64,01" type="image/gif" />
          <img
            data-src={blogRightShape.dataSrc}
            className="index-airplane-top-right lazyloaded"
            alt={blogRightShape.titleTopRight}
            title={blogRightShape.titleTopRight}
            src={blogRightShape.dataSrc}
            loading="lazy"
            height="80"
            width="229"
          />
        </picture>
        <svg
          width="325px"
          height="314px"
          className={`svg-sprite doted-curve-svg ${styles.blogSvg}`}
        >
          <use href={baseUrl + "/public/images/shapes.svg?v=#dotted-curve"}/>
        </svg>
      </figure>

      <div className="index-atp-blog-inner container-block">
        <h2 className={`index-blog-heading index-heading-blue-atp`}>Blog</h2>
        <div className="index-atp-slider">
          {blogItems.map((el, index) => {
            return (
              <div className="index-atp-blog-item" key={index}>
                <figure className="index-atp-blog-item-figure">
                  <a href="/news">
                    <img
                      srcSet={el.img}
                      className="index-atp-blog-item-img lazyload"
                      alt={el.name}
                      title={el.name}
                      loading="lazy"
                    />
                  </a>
                  <figcaption className="index-atp-blog-item-description">
                    <div>
                      <a href="#">{el.date}</a>
                    </div>
                    <a className="index-atp-blog-item-h3" href="/news">
                      {el.name}
                    </a>
                    <div className="index-atp-blog-item-text">{el.desc}</div>
                  </figcaption>
                </figure>
              </div>
            );
          })}
        </div>
        <div className="blog-link">
          <a className="index-blog-link" href="/news">
            Read More >
          </a>
        </div>
      </div>
    </section>
  );
};

export default Blog;
